
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M34.837 1a8.972 8.972 0 016.364 2.636A8.972 8.972 0 0143.837 10h0v24.837a8.972 8.972 0 01-2.636 6.364 8.972 8.972 0 01-6.364 2.636h0H10a8.972 8.972 0 01-6.364-2.636A8.972 8.972 0 011 34.837h0V10a8.972 8.972 0 012.636-6.364A8.972 8.972 0 0110 1h0z","stroke":"#504F4F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M11.82 23.36l10.725 4.02-1.34 1.34-3.522.502-.502 3.522-1.339 1.34-4.021-10.725zm2.051 2.049l2.277 6.074.476-3.321 3.319-.475-6.072-2.278zM17.215 11.4v1.076H22v1.2h-2.522a7.068 7.068 0 013.097 5.262h1.102v3.354H22.63a5.868 5.868 0 004.153 5.019v-.834h3.354v.834a5.868 5.868 0 004.155-5.018h-1.047v-3.355H36.6v3.354h-1.102a7.066 7.066 0 01-5.36 6.262v1.277h-3.353v-1.278a7.066 7.066 0 01-5.36-6.26h-1.102v-3.355h1.046a5.868 5.868 0 00-4.153-5.018v.834h-3.354v-.834a5.868 5.868 0 00-4.155 5.018h1.047v3.354H7.4v-3.354h1.102a7.068 7.068 0 013.098-5.263l-2.523.002v-1.2l4.784-.001V11.4h3.354zm11.723 16.276h-.954v.954h.954v-.954zm-12.861-7.66v1.2H15v-1.2h1.077zm2.154 0v1.2h-1.077v-1.2h1.077zm-4.308 0v1.2h-1.077v-1.2h1.077zm15.077 0v1.2h-1.077v-1.2H29zm2.154 0v1.2h-1.077v-1.2h1.077zm-4.308 0v1.2H25.77v-1.2h1.077zm8.553.122h-.953v.954h.953v-.954zm-12.923 0h-.953v.954h.953v-.954zm-12.923 0H8.6v.954h.953v-.954zm6.462-7.538h-.954v.953h.954V12.6z","fill":"#BF9C5F","fill-rule":"nonzero"}})])])
          )
        }
      }
    